export default {
  ARCHIVED_OPPORTUNITIES: 'archivedOpportunities',
  OPPORTUNITIES_CREATED_BY_ME: 'opportunitiesCreatedByMe',
  OPPORTUNITIES_CREATED_BY_OTHERS: 'opportunitiesCreatedByOthers',
  EXPIRED_OPPORTUNITIES: 'expiredOpportunities',
};
